// CourseList.js
import React, { useState } from 'react'
import Course from '../common/Course'
import Loading from '../common/Loading'
import {
  checkStatusMainCourses,
  getCourseStatus,
  getProgressCourse, isEarnedCourse,
} from '../../utils/helpers'
import { Accordion, AccordionPanel } from './Accordion'

const CourseList = ({ mainCourses, miniCourses, loading }) => {
  if (loading) return <Loading />

  const mainCourseCompleted = () => {
    return checkStatusMainCourses(mainCourses)
  }

  const renderCourse = () => {
    if (mainCourses.length === 0) {
      return <p className="text-center">Course not found</p>
    }

    return mainCourses.map((course, index) => {
      const process = getProgressCourse(course)
      const status = getCourseStatus(course)
      const isEarned = isEarnedCourse(course)

      return (
        <Course
          key={index}
          id={course.id}
          haveBg={status !== 'un_start'}
          title={course.title}
          description={course.description}
          progress={process}
          status={status}
          badges={course?.badges}
          isEarned={isEarned}
          partnerLogo={course.partner_logo}
        />
      )
    })
  }

  const renderMiniCourse = () => {
    if (miniCourses.length === 0) {
      return <p className="text-center">Course not found</p>
    }

    return miniCourses.map((course, index) => {
      const process = getProgressCourse(course)
      const status = getCourseStatus(course)
      const isEarned = isEarnedCourse(course)
      return (
        <Course
          key={index}
          haveBg={status !== 'un_start'}
          id={course.id}
          title={course.title}
          description={course.description}
          progress={process}
          status={status}
          badges={course?.badges}
          isEarned={isEarned}
          partnerLogo={course.partner_logo}
        />
      )
    })
  }

  return (
    <Accordion>
      <AccordionPanel title="Main Quest">
        <div className="flex flex-col gap-4">{renderCourse()}</div>
      </AccordionPanel>

      <AccordionPanel title="Mini Course">
        <div className="flex flex-col gap-4">{renderMiniCourse()}</div>
      </AccordionPanel>
    </Accordion>
  )
}

export default CourseList
